module.exports = __webpack_public_path__ + "static/media/bodyshock-icon.916ba65d.svg";